import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { ChangeEmployerService } from '../change-employer.service';
import { Subscription } from 'rxjs';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { EntityLicenseModel } from '../../../model/entityLicenseModel';
import { WorkflowStepModel } from '../../../model/workflowStepModel';
import { ContentPageModel } from '../../../model/contentPageModel';
import { Router } from '@angular/router';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { WorkflowModel } from '../../../model/workflowModel';
import { StorageService } from '../../../shared/security/StorageService';
import { SpinnerService } from '../../../shared/spinner/spinner.service';

@Component({
  selector: 'app-start-change-employer',
  templateUrl: './start-change-employer.component.html',
  styleUrls: ['./start-change-employer.component.css']
})
export class StartChangeEmployerComponent implements OnInit, OnDestroy {


  title: string = ""

  review: boolean = false;
  printPage: boolean = false;
  employmentInfoDisplay: boolean = true;
  employmentInfo: EntityLicenseModel;
  steps: Array<WorkflowStepModel> = new Array<WorkflowStepModel>();
  startStepContent: ContentPageModel;

  startFunction: StartFunctionResponseModel = {};

  workflow: WorkflowModel;

  public now: Date = new Date();

  userSessionId: number;

  noCurrentEmployer: string;

  constructor(private currentPageWatcher: CurrentPageWatcherService,
    private changeEmployerService: ChangeEmployerService,
    private router: Router,
    private startFunctionService: StartFunctionService,
    private storage: StorageService,
    private spinner: SpinnerService) {

    this.userSessionId = this.storage.getSessionData().userSessionId;

    this.steps = new Array<WorkflowStepModel>();

    this.startFunction = this.storage.getStartFunctionData();
    if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {
      this.title = this.startFunction.Workflow.WorkflowDisplayName;
      this.steps = this.startFunction.Workflow.Steps;
      this.startStepContent = this.steps[0].StepMessage;
      this.workflow = this.startFunction.Workflow;
      console.log("workflow : ", this.workflow);
    }
    this.changeEmployerService.getEmploymentInformation(this.userSessionId).subscribe(empInfoData => {

      console.log("empInfoData", empInfoData);
      this.employmentInfo = empInfoData;
      console.log("First Step : ", this.startStepContent);
    },
      err => {
        if (err.status == 404) {
          this.employmentInfo = null;
          this.noCurrentEmployer = "No Employing Broker";
          this.spinner.hide();
        }

      }

    );
  }

  ngOnInit() {
    this.currentPageWatcher.pageChanged().emit(this.title);
  }

  startWorkFlow() {
    if (this.employmentInfo != null) {
      this.router.navigate(['/changeEmployerNotification']).then(() => {
        this.changeEmployerService.getNotifyEmploymentInformation().emit(this.employmentInfo);
        this.startFunctionService.getNotifyStepInProgress().emit(true);

      })
    } else {
      this.router.navigate(['/selectNewEmployer']).then(() => {
        //  this.startFunctionService.sendStartFunctionBrokerResp(this.startFunction);
        this.changeEmployerService.getNotifyEmploymentInformation().emit(this.employmentInfo);
      this.startFunctionService.getNotifyStepInProgress().emit(true);

      })

    }

  }
  goBackHome() {
    this.router.navigate(['/home']);
  }

  ngOnDestroy(): void {
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/change-employer/start-change-employer/start-change-employer.component.ts